import { DefineGetters } from "vuex-type-helper";
import {
  WatercraftTypeGetters,
  WatercraftTypeState,
  IWatercraftType
} from "./types";

export const getters: DefineGetters<
  WatercraftTypeGetters,
  WatercraftTypeState
> = {
  getWatercraftTypeById: (state: WatercraftTypeState) => (id: string) =>
    state.watercraftTypes.find((watercraftType: IWatercraftType) => {
      return watercraftType._id === id;
    }),
  editingWatercraftType: (state: WatercraftTypeState) => state.editing,
  watercraftTypes: (state: WatercraftTypeState) => state.watercraftTypes,
  isLoading: (state: WatercraftTypeState) => state.makingApiRequest,
  getWatercraftTypesLinks: (state: WatercraftTypeState) => state.links,
  getTotalRecords: ({ links, watercraftTypes }: WatercraftTypeState) =>
    links && links.totalRecords ? links.totalRecords : watercraftTypes.length
};
